/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        // document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        // document.querySelector("#miniCartUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        // reset bar
        if (cartSettings.free_shipping_method === "threshold") {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(cartSettings.free_shipping_threshold * 100)}</b> more for <b>FREE SHIPPING</b>`;
        } else if (cartSettings.free_shipping_method === "subscription") {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
        }
        document.querySelector("#miniCartHeaderBarInner").style.width = `0`;
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price)}</b> more for <b>FREE SHIPPING</b>`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        // save supplement data
        const supplementData = cartData[item.key];

        // determine if item has properties
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (supplementData.compare_at_price) {
                comparePrices.push(supplementData.compare_at_price * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <s>${price(greatestComparePrice)}</s>
                        <span>(Save ${price(greatestComparePrice - item.final_line_price)})</span>
                    `;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // check if selling plan exists
            if (!supplementData["selling_plan_id"]) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}" 
                     data-plan="${supplementData["selling_plan_id"]}"
                >
               ${supplementData["selling_plan_name"]}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_202_6265)"> <path d="M18.518 4.73986H1.48297C1.06797 4.73986 0.730469 4.40236 0.730469 3.98736C0.730469 3.57236 1.06797 3.23486 1.48297 3.23486H18.518C18.933 3.23486 19.2705 3.57236 19.2705 3.98736C19.2705 4.40236 18.933 4.73986 18.518 4.73986Z" fill="black"/> <path d="M10.389 19.7698H9.61403C6.84403 19.7698 5.31903 19.7698 4.23403 18.7573C3.15153 17.7448 3.04903 16.2223 2.86403 13.4573L2.40403 6.54485C2.37653 6.12985 2.68903 5.77235 3.10403 5.74485C3.51903 5.71735 3.87653 6.02985 3.90403 6.44485L4.36403 13.3573C4.52903 15.8173 4.61153 17.0523 5.26153 17.6598C5.91153 18.2673 7.14903 18.2673 9.61403 18.2673H10.389C12.854 18.2673 14.0915 18.2673 14.7415 17.6598C15.3915 17.0523 15.474 15.8173 15.639 13.3573L16.099 6.44485C16.1265 6.02985 16.4865 5.71735 16.899 5.74485C17.314 5.77235 17.6265 6.12985 17.599 6.54485L17.139 13.4573C16.954 16.2223 16.854 17.7448 15.769 18.7573C14.6865 19.7698 13.159 19.7698 10.389 19.7698Z" fill="black"/> <path d="M7.99367 14.7601C7.61117 14.7601 7.28617 14.4701 7.24617 14.0826L6.74617 9.07258C6.70367 8.66008 7.00617 8.29008 7.41867 8.25008C7.83117 8.20758 8.20117 8.51008 8.24117 8.92258L8.74117 13.9326C8.78367 14.3451 8.48117 14.7151 8.06867 14.7551C8.04367 14.7576 8.01867 14.7601 7.99367 14.7601Z" fill="black"/> <path d="M12.0054 14.7601C11.9804 14.7601 11.9554 14.7601 11.9304 14.7551C11.5179 14.7126 11.2154 14.3451 11.2579 13.9326L11.7579 8.92258C11.8004 8.51008 12.1679 8.20758 12.5804 8.25008C12.9929 8.29258 13.2954 8.66008 13.2529 9.07258L12.7529 14.0826C12.7129 14.4701 12.3879 14.7601 12.0054 14.7601Z" fill="black"/> <path d="M15.5122 4.73992C15.4472 4.73992 15.4147 4.73992 15.3847 4.73992C14.8272 4.72492 14.2947 4.54742 13.8422 4.21992C13.3897 3.89492 13.0522 3.44492 12.8622 2.92242C12.8522 2.89492 12.8422 2.86242 12.8197 2.79992L12.7222 2.50742C12.6572 2.31492 12.6172 2.18992 12.5897 2.13742C12.4797 1.92742 12.2747 1.77992 12.0422 1.74242C11.9822 1.73242 11.8497 1.73242 11.6497 1.73242H8.35469C8.15219 1.73242 8.01969 1.73242 7.96219 1.74242C7.72719 1.77992 7.52469 1.92742 7.41469 2.13742C7.38719 2.18992 7.34469 2.31742 7.28219 2.50742L7.18469 2.79992C7.16469 2.86242 7.15219 2.89242 7.14219 2.92242C6.95219 3.44492 6.61469 3.89492 6.16219 4.21992C5.70969 4.54492 5.17719 4.72492 4.61969 4.73992C4.58969 4.73992 4.55719 4.73992 4.49219 4.73992V3.23742C4.53719 3.23742 4.56219 3.23742 4.58219 3.23742C5.10219 3.22492 5.55219 2.89992 5.72719 2.41242C5.73469 2.39242 5.74219 2.36992 5.75719 2.32742L5.85469 2.03492C5.94719 1.75742 5.99719 1.60492 6.07969 1.44492C6.40719 0.814922 7.02219 0.372422 7.72469 0.259922C7.90219 0.232422 8.06219 0.232422 8.35469 0.232422H11.6497C11.9422 0.232422 12.1022 0.232422 12.2797 0.259922C12.9822 0.372422 13.5947 0.814922 13.9247 1.44492C14.0072 1.60242 14.0572 1.75492 14.1497 2.03242L14.2472 2.32742C14.2622 2.37242 14.2697 2.39242 14.2772 2.41242C14.4547 2.89992 14.9047 3.22492 15.4222 3.23742C15.4422 3.23742 15.4672 3.23742 15.5122 3.23742V4.73992Z" fill="black"/> </g> <defs> <clipPath id="clip0_202_6265"> <rect width="20" height="20" fill="white"/> </clipPath> </defs> </svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price + cartSettings.protection_upsell.variants[0].price);
    } else {
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price);
    }
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // if discount code activated
    if (this.classList.contains('discount')) {
        const discountCount = sessionStorage.getItem('countdownEndTime')
        if (discountCount && discountCount === "finished") {
            // go to checkout
            window.location.href = `${Shopify.routes.root}checkout`;
            return;
        }
        // open the discount popup and select the product offer
        document.querySelector('#miniCartFooterDiscount').classList.add('active');
        document.querySelector('#miniCartFooterDiscountTitle span').textContent = cart.items[cart.items.length - 1].product_title;
        document.querySelector(`.miniCartFooterDiscountProductsItem[data-id="${cart.items[cart.items.length - 1].product_id}"]`).classList.add('active');
        activateDiscountTimer();
        return;
    }

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}

// Discount popup
// close popup and go to checkout
document.querySelectorAll('#miniCartFooterDiscountExit,.miniCartFooterDiscountBottomReject').forEach(el => {
    el.addEventListener('click', function () {
        this.closest('#miniCartFooterDiscount').classList.remove('active');
        // go to checkout
        window.location.href = `${Shopify.routes.root}checkout`;
    })
})

// open the counter and offer when checkout
document.querySelectorAll('.miniCartFooterDiscountBottomAccept').forEach(el => {
    el.addEventListener('click', async function () {

        this.classList.add("loading");

        // create an add object for the discount add-on
        let formData = {
            items: [{
                quantity: 1,
                id: parseInt(this.closest('.miniCartFooterDiscountProductsItem')?.dataset.variant),
            }]
        };

        // add to cart
        await addProduct(formData);

        // apply coupon
        // const codeURL = `/discount/${document.querySelector('.miniCartFooterDiscountProductsItem.active')?.dataset.code}`;
        // await fetch(codeURL);

        // remove loading animation
        this.classList.remove("loading");

        // go to checkout
        window.location.href = `${Shopify.routes.root}checkout`;
    })
})

// discount countdown display
const countDisplay = document.querySelector('#miniCartFooterDiscountCounterInner span');

// start the countdown each open
function activateDiscountTimer() {

    const endTime = sessionStorage.getItem('countdownEndTime');
    const currentTime = Date.now();

    // check time left and update count
    if (endTime && currentTime < parseInt(endTime, 10)) {
        updateDisplay(parseInt(endTime, 10));
        return;
    }

    // if no timer - start a new session countdown - 10 minutes
    const newEndTime = currentTime + 600 * 1000;
    sessionStorage.setItem('countdownEndTime', String(newEndTime));

    updateDisplay(newEndTime);
}

let countdownInterval;

// update the display every second
function updateDisplay(endTime) {
    // restart every open
    clearInterval(countdownInterval);

    countdownInterval = setInterval(() => {
        const currentTime = Date.now();
        const timeLeft = Math.floor((endTime - currentTime) / 1000);

        if (timeLeft <= 0) {
            clearInterval(countdownInterval);
            countDisplay.textContent = '00:00';
            // mark as finished to block reopening
            sessionStorage.setItem('countdownEndTime', "finished");
            // hide popup
            document.querySelector('#miniCartFooterDiscount').classList.remove('active');
            return;
        }

        countDisplay.textContent = formatTime(timeLeft);
    }, 1000);
}

// format the display time
function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}